export const MainErrorFallback = () => {
  console.info('main.tsx_1');

  return <div>error!!</div>;
};
